<template>
  <sliding-tabs
      v-if="isServiceProviderCatalogOccupationsLoaded"
      :activeTab="serviceProviderOccupationName"
      class="OCCUPATION-TABS">
    <template v-for="{ id, occupationName } in tabOccupations">
      <sliding-tabs-content
          v-if="occupationName"
          :key="occupationName"
          :name="occupationName"
          :active="occupationName === serviceProviderOccupationName"
          :titleProps="{
            title: occupationName,
            to: {
              name: occupationName === reviewsTitle
                ? 'pro-public-profile::reviews'
                : 'pro-public-profile',
              params: { serviceProviderOccupationId: id }
            },
          }"
      />
    </template>
  </sliding-tabs>
</template>

<script>
import { mapGetters } from 'vuex';

import SlidingTabs from '@/components/SlidingTabs';
import SlidingTabsContent from '@/components/SlidingTabs/SlidingTabsContent';

export default {
  name: 'occupation-tabs',
  components: {
    SlidingTabs,
    SlidingTabsContent,
  },
  data () {
    return {
      tabOccupations: {},
      reviewsTitle: 'Show all Reviews',
      occupationId: null,
    };
  },
  computed: {
    ...mapGetters('fullproprofile', [
      'serviceProviderCatalogOccupations',
    ]),
    // },
    isReviews () {
      return this.$route.meta.reviews;
    },
    serviceProviderOccupationId () {
      return parseInt(this.$route.params.serviceProviderOccupationId, 10);
    },
    serviceProviderOccupationName () {
      let name = 'Show all Reviews';

      if (!this.serviceProviderOccupationId) {
        return name;
      }
      if (this.isReviews) {
        return name;
      }
      const maybeOccupation = this.serviceProviderCatalogOccupations[
        this.serviceProviderOccupationId
      ];

      if (maybeOccupation && !this.isReviews) {
        // eslint-disable-next-line prefer-destructuring
        name = maybeOccupation.occupationName;
      }

      return name;
    },
    isServiceProviderCatalogOccupationsLoaded () {
      return !!Object.keys(this.serviceProviderCatalogOccupations).length;
    },
  },
  watch: {
    isServiceProviderCatalogOccupationsLoaded (val) {
      if (val) {
        this.setServiceProviderOccupationId();
        this.addAllReviews();
      }
    },
  },
  mounted () {
    this.setServiceProviderOccupationId();
    this.addAllReviews();
  },
  methods: {
    addAllReviews () {
      this.tabOccupations = Object.assign({}, this.serviceProviderCatalogOccupations);

      this.$set(
        this.tabOccupations,
        // set the property name to a value higher that other occupation Ids so it shows last in list.
        this.occupationId * 2,
        {
          id: this.occupationId,
          occupationName: this.reviewsTitle,
          occupation_name: 'show_all_reviews',
        });
    },
    setServiceProviderOccupationId () {
      this.occupationId = parseInt(this.$route.params.serviceProviderOccupationId, 10);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .OCCUPATION-TABS {
    @include margin-bottom(3, 4);
    height: 42px;
    display: flex;
    flex: 0 0 auto;
    border-bottom: 1px solid $color-gray30;
    text-transform: capitalize;
  }
</style>
